import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import xhr from 'i18next-xhr-backend';
import store from 'store';
import ru from './config/i18n/ru.json';
import uk from './config/i18n/uk.json';

let currentLang = 'uk';

if (!store.get('lang')) {
  store.set('lang', currentLang);
} else {
  currentLang = store.get('lang');
}

let options = {
  saveMissing: false,
  lng: currentLang,
  fallbackLng: 'ru',
  fallbacks: true,
  keySeparator: '.',
  interpolation: {
    escapeValue: false,
  },
  react: {
    useSuspense: false,
  },
  resources: {
    ru: {
      translation: ru,
    },
    uk: {
      translation: uk,
    },
  },
};

i18n.use(xhr).use(initReactI18next).init(options);

export default i18n;
